import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles((theme) => ({
  margin: {
    marginBottom: theme.spacing(4),
  },
  title: {
    fontSize: "40px",
    lineHeight: "55px",
    fontWeight: 700,
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
  },
  titleAddOn: {
    display: "flex",
    marginLeft: theme.spacing(3),
  },
  button: {
    width: "auto",
    "& .MuiSvgIcon-root": {
      marginRight: theme.spacing(1),
      width: "20px",
      height: "20px",
    },
  },
  altButton: {
    width: "auto",
    marginRight: theme.spacing(3),
    "& .MuiSvgIcon-root": {
      marginRight: theme.spacing(1),
      width: "20px",
      height: "20px",
    },
  },
  back: {
    fontWeight: 700,
    fontSize: "14px",
    display: "inline-flex",
    marginBottom: theme.spacing(2.5),
    paddingLeft: theme.spacing(0),
    "&.MuiButton-root:hover,&.MuiButton-root:visited": {
      backgroundColor: "transparent",
      color: theme.custom.linkHover.color,
      transition: "none",
    },
    "& .MuiTouchRipple-root": {
      display: "none",
    },
    "& .MuiSvgIcon-root": {
      marginLeft: "-2px",
    },
  },
  icon: {
    marginRight: theme.spacing(1.2),
  },
  underlineNone: {
    textDecoration: "none",
  },
}));
